// asset imports
import "@/assets/styles/argon.scss";

export default {};
